module.exports = __webpack_public_path__ + "img/imagen1.397b8776.png";